/* eslint-disable */
import { CURRENCIES_ASSOCIATION } from 'ggApp/modules/store/constants';
import { formatPriceByLanguage } from 'ggApp/utils/money';

export const getPrices = (activeStore, rentalPlan, retailtPrice) => {
    let price = null;
    let oldPrice = null;
    let marketPrice = null;
    if (activeStore.default_currency) {
        const currency = CURRENCIES_ASSOCIATION[activeStore.default_currency];
        if (rentalPlan.price) {
            price = rentalPlan.price
                && formatPriceByLanguage(
                    rentalPlan.price,
                    currency,
                    activeStore.activeLanguage,
                );
            oldPrice = rentalPlan.oldPrice
                && formatPriceByLanguage(
                    rentalPlan.oldPrice,
                    currency,
                    activeStore.activeLanguage,
                );
        }
        if (retailtPrice) {
            marketPrice = retailtPrice
                && formatPriceByLanguage(
                    retailtPrice,
                    currency,
                    activeStore.activeLanguage,
                );
        }
    }
    return {
        price,
        oldPrice,
        marketPrice,
    };
};

export default getPrices;
